// Thin wrapper around gtag so call sites don't each need their own
// "is gtag loaded" guard. Wrapped in try/catch deliberately — analytics
// must never be able to break real site functionality (uploading,
// converting, downloading) if gtag fails to load or throws.
export function trackEvent(eventName, params = {}) {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    }
  } catch (e) {
    // Swallow — see comment above.
  }
}
